"use client";

import React from "react";
import type { Nullable } from "../../../@types/generic";
import { getWindow } from "../../../helpers/getWindow";
import { Button } from "../../Button";
import styles from "./magnifier.module.scss";

export const Magnifier: React.FC = () => {
    const window = getWindow();
    const autosuggestInput = window?.document.querySelector(
        "#autosuggest-container input"
    ) as Nullable<HTMLInputElement>;

    const onClickMagnifier = (): void => {
        window?.scroll({ top: 0, behavior: "smooth" });
        autosuggestInput?.focus();
    };
    return (
        <Button
            variant="unstyled"
            className={styles.wrapper}
            onClick={onClickMagnifier}
            aria-label="Suche öffnen"
        >
            <span className="icon-magnifier" />
        </Button>
    );
};
